/* Raghu 27/10/2022 3225736869 Card alignment fixes */
import React from 'react';
import JobDetailsForm from './JobdetailsForm';

function JobDetails({jobCode, setValue}) {
  return (
    <div className={`mb-0`}>
      <JobDetailsForm setValue={setValue} jobCode={jobCode}/>
    </div>
  );
}

export default JobDetails;
